<div class="form-rules-box">
  <div class="form-rules-box__header">
    {{ title }}
  </div>
  <div class="form-rules-box__list">
    @for (rule of rules; track rule.label) {
      <div
        class="form-rules-box__rule"
        [class.form-rules-box__rule--valid]="rule.valid"
      >
        <span class="form-rules-box__rule-text">{{ rule.label }}</span>
      </div>
    }
  </div>
</div>

